import { useAuthStore, type AuthStore } from '../stores/authStore'

import { requestPlanSelection, resetPlanSelection } from '@/features/credits'

export type SetPlanOutcome = { next: 'signup' } | { next: 'summary' }

export interface AuthSetPlanDeps {
  store?: Pick<AuthStore, 'getToken'>
  requestPlan?: () => void
  resetPlan?: () => void
}

/**
 * Contract 06's set-plan branch. Auth decides only whether a session exists; module 11 owns the
 * plan intent, state and rendered pricing surface through its public barrel.
 */
export class AuthSetPlanFlow {
  private readonly store: Pick<AuthStore, 'getToken'>
  private readonly requestPlan: () => void
  private readonly resetPlan: () => void

  constructor(deps: AuthSetPlanDeps = {}) {
    this.store = deps.store ?? useAuthStore()
    this.requestPlan = deps.requestPlan ?? requestPlanSelection
    this.resetPlan = deps.resetPlan ?? resetPlanSelection
  }

  execute(): SetPlanOutcome {
    if (!this.store.getToken()) {
      this.resetPlan()
      return { next: 'signup' }
    }

    this.requestPlan()
    return { next: 'summary' }
  }
}
